// extracted by mini-css-extract-plugin
module.exports = {"card":"TourAlternateYears_card__07jgQ","column":"TourAlternateYears_column__7aXKI"};